// import React, { useEffect, useRef, useState } from "react";
// import Topbar from "../../components/Topbar/Topbar";
// import { Search_icon } from "../../assets/img";
// import { Table } from "../../components/Table/Table";
// import { useLocation, useNavigate } from "react-router-dom";
// import { get, post } from "../../Services/ApiHandler";
// import { URLS } from "../../Services/Constant";
// import moment from "moment";
// import { useGlobalContext } from "../../Services/PaginationGlobal";
// import { toast } from "react-toastify";

// function AuditLog() {
//   const [page, setPage] = useState(1);
//   const [isSearch, setIsSearch] = useState("");
//   const [lastKnownPage, setLastKnownPage] = useState(1);
//   const debounceRef = useRef(null);

//   const { paginationData, setpaginationData } = useGlobalContext();
//   const { pathname } = useLocation();
//   const path = pathname?.replace("/", "");
//   const navigate = useNavigate();

//   const [isAuditLog, setAuditLog] = useState([]);
//   const [pagination, setPagination] = useState("");
//   const pageRef = useRef(page);

//   useEffect(() => {
//     pageRef.current = page;
//   }, [page]);

//   const fetchLog = async (pageNumber = 1, searchValue = "") => {
//     try {
//       let query = `${URLS.AUDIT_LOG}?page=${pageNumber}&search=${encodeURIComponent(searchValue)}`;
//       const res = await get(query);
//       console.log("AUDITLOGGG", res);

//       if (res?.status === "success") {
//         setAuditLog(res?.data);

//         const hasNext = !!res?.next;
//         const computedLastPage = hasNext ? pageNumber + 1 : pageNumber;
//         const newLastPage = Math.max(lastKnownPage, computedLastPage);
//         setLastKnownPage(newLastPage);

//         setPagination({
//           current_page: pageNumber,
//           last_page: newLastPage,
//         });
//       }
//     } catch (err) {
//       console.log("ERROR", err);
//     }
//   };

//   useEffect(() => {
//     fetchLog();
//   }, []);

//   useEffect(() => {
//     fetchLog(page, isSearch);
//     setpaginationData((prev) => ({
//       ...prev,
//       [path]: {
//         ...prev?.[path],
//         page: page,
//       },
//     }));
//   }, [page]);

//   // Fetch when search changes — reset page and lastKnownPage to 1
//   useEffect(() => {
//     // if (!isMounted.current) return;
//     setPage(1);
//     setLastKnownPage(1);
//     fetchLog(1, isSearch);
//     setpaginationData((prev) => ({
//       ...prev,
//       [path]: {
//         ...prev?.[path],
//         page: 1,
//         search: isSearch,
//       },
//     }));
//   }, [isSearch]);

//   const handleSearchChange = (e) => {
//     const val = e.target.value;
//     clearTimeout(debounceRef.current);
//     debounceRef.current = setTimeout(() => {
//       setIsSearch(val);
//     }, 400);
//   };

//   const columns = React.useMemo(() => {
//     return [
//       {
//         Header: "S.No",
//         accessor: "S.No",
//         Cell: ({ row }) => (
//           <p className="red">{(page - 1) * 10 + (row.index + 1)}</p>
//         ),
//       },
//       {
//         Header: "Admin ID",
//         accessor: "admin_code",
//         Cell: ({ value, row }) => (
//           <p
//             className="text-nowrap"
//             style={{
//               borderBottom: "1px solid #000",
//               cursor: "pointer",
//               width: "auto",
//             }}
//             onClick={() =>
//               navigate("/add-admin", {
//                 state: {
//                   type: "edit",
//                   id: row.original.admin_id,
//                   page: pageRef.current,
//                 },
//               })
//             }
//           >
//             {value}
//           </p>
//         ),
//       },
//       {
//         Header: "Admin Name",
//         accessor: "admin_name",
//         Cell: ({ value }) => <p className="text-nowrap">{value}</p>,
//       },
//       {
//         Header: "Role",
//         accessor: "role_name",
//         Cell: ({ value }) => <p className="text-nowrap">{value}</p>,
//       },
//       {
//         Header: "IP Address",
//         accessor: "ip_address",
//         Cell: ({ value }) => <p className="text-nowrap">{value}</p>,
//       },
//       {
//         Header: "Login Date",
//         accessor: "login_at",
//         Cell: ({ value }) =>
//           value && (
//             <p className="text-nowrap">
//               {moment(value).format("DD MMM YYYY")} -{" "}
//               {moment(value).format("h:mm A")}
//             </p>
//           ),
//       },
//       {
//         Header: "Logout Date",
//         accessor: "logout_at",
//         Cell: ({ value }) =>
//           value ? (
//             <p className="text-nowrap">
//               {moment(value).format("DD MMM YYYY")} -{" "}
//               {moment(value).format("h:mm A")}
//             </p>
//           ) : (
//             <p style={{ textAlign: "center" }}>-</p>
//           ),
//       },
//       {
//         Header: "Device Info",
//         accessor: "device_info",
//         Cell: ({ value }) => <p className="text-nowrap">{value}</p>,
//       },
//     ];
//   }, [isAuditLog, page]);

//   const handlerForceLogout = async () => {
//     try {
//       const res = await post(URLS.FORCELOGOUT);
//       if (res?.status === "success") {
//         toast.success("Force Logout Success");
//       }
//     } catch (err) {
//       console.log("Error", err);
//     }
//   };

//   console.log(
//     "isAuditLog",
//     isAuditLog,
//     "lastKnownPage",
//     lastKnownPage,
//     "pagination",
//     pagination,
//   );

//   return (
//     <div>
//       <Topbar header={"Settings"} subHead={"Audit Log"} />
//       <div className="d-flex ac-jb">
//         <h2 className="f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26">
//           Audit Logs
//         </h2>
//         <div className="d-flex gap-3" style={{ alignItems: "center" }}>
//           <div className="search-input">
//             <input
//               type="text"
//               placeholder="Search"
//               style={{ border: "none", width: "150px" }}
//               onChange={handleSearchChange}
//             />
//             <img src={Search_icon} className="search" alt="search" />
//           </div>
//           <button
//             onClick={() => handlerForceLogout()}
//             className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn"
//           >
//             Force Log Out
//           </button>
//         </div>
//       </div>
//       <Table
//         pageno={pageRef.current}
//         columns={columns}
//         setPageno={setPage}
//         pagecount={pagination}
//         data={isAuditLog}
//         show={true}
//       />
//     </div>
//   );
// }

// export default AuditLog;
import React, { useEffect, useRef, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { Search_icon } from "../../assets/img";
import { Table } from "../../components/Table/Table";
import { useLocation, useNavigate } from "react-router-dom";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import moment from "moment";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { toast } from "react-toastify";
import { checkPermission } from "../redux/api/PermissionManager";

function AuditLog() {
  const [page, setPage] = useState(1);
  const [isSearch, setIsSearch] = useState("");
  const [lastKnownPage, setLastKnownPage] = useState(1);
  const debounceRef = useRef(null);
  const isFirstMount = useRef(true); // ✅ prevent double-fetch on mount

  const { setpaginationData } = useGlobalContext();
  const { pathname } = useLocation();
  const path = pathname?.replace("/", "");
  const navigate = useNavigate();

  const [isAuditLog, setAuditLog] = useState([]);
  const [pagination, setPagination] = useState("");
  const pageRef = useRef(page);

  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  const fetchLog = async (pageNumber = 1, searchValue = "") => {
    try {
      let query = `${URLS.AUDIT_LOG}?page=${pageNumber}&search=${encodeURIComponent(searchValue)}`;
      const res = await get(query);

      if (res?.status === "success") {
        setAuditLog(res?.data);

        const hasNext = !!res?.next;
        const computedLastPage = hasNext ? pageNumber + 1 : pageNumber;

        setLastKnownPage((prev) => {
          const newLastPage = Math.max(prev, computedLastPage);
          setPagination({
            current_page: pageNumber,
            last_page: newLastPage,
          });
          return newLastPage;
        });
      }
    } catch (err) {
      console.log("ERROR", err);
    }
  };

  // ✅ Single mount fetch
  useEffect(() => {
    fetchLog(1, "");
  }, []);

  // ✅ Page change — skip on first mount
  useEffect(() => {
    if (isFirstMount.current) {
      isFirstMount.current = false;
      return;
    }
    fetchLog(page, isSearch);
    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], page },
    }));
  }, [page]);

  // ✅ Search change — reset page
  useEffect(() => {
    if (isFirstMount.current) return;
    setPage(1);
    setLastKnownPage(1);
    fetchLog(1, isSearch);
    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], page: 1, search: isSearch },
    }));
  }, [isSearch]);

  const handleSearchChange = (e) => {
    const val = e.target.value;
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setIsSearch(val);
    }, 400);
  };

  const columns = React.useMemo(() => {
    return [
      {
        Header: "S.No",
        accessor: "sno", // ✅ Fixed: no dots in accessor
        Cell: ({ row }) => (
          <p className="red">{(pageRef.current - 1) * 10 + (row.index + 1)}</p>
        ),
      },
      {
        Header: "Admin ID",
        accessor: "admin_code",
        Cell: ({ value, row }) => {
          console.log("DASDKSAKDSAKDK", value, row);

          return (
            <p
              className="text-nowrap"
              style={{ borderBottom: "1px solid #000", cursor: "pointer" }}
              onClick={() =>
                checkPermission("CAN-VIEW-ADMIN_LIST") &&
                navigate("/add-admin", {
                  state: {
                    type: "edit",
                    id: row.original.admin_id,
                    page: pageRef.current,
                  },
                })
              }
            >
              {value}
            </p>
          );
        },
      },
      {
        Header: "Admin Name",
        accessor: "admin_name",
        Cell: ({ value }) => <p className="text-nowrap">{value}</p>,
      },
      {
        Header: "Role",
        accessor: "role_name",
        Cell: ({ value }) => <p className="text-nowrap">{value}</p>,
      },
      {
        Header: "IP Address",
        accessor: "ip_address",
        Cell: ({ value }) => <p className="text-nowrap">{value || "-"}</p>,
      },
      {
        Header: "Login Date",
        accessor: "login_at",
        Cell: ({ value }) =>
          value ? (
            <p className="text-nowrap">
              {moment(value).format("DD MMM YYYY")} -{" "}
              {moment(value).format("h:mm A")}
            </p>
          ) : (
            <p style={{ textAlign: "center" }}>-</p>
          ),
      },
      {
        Header: "Logout Date",
        accessor: "logout_at",
        Cell: ({ value }) =>
          value ? (
            <p className="text-nowrap">
              {moment(value).format("DD MMM YYYY")} -{" "}
              {moment(value).format("h:mm A")}
            </p>
          ) : (
            <p style={{ textAlign: "center" }}>-</p>
          ),
      },
      {
        Header: "Device Info",
        accessor: "device_info",
        Cell: ({ value }) => <p className="text-nowrap">{value || "-"}</p>,
      },
    ];
  }, []); // ✅ Empty deps — stable column reference

  const handlerForceLogout = async () => {
    try {
      const res = await post(URLS.FORCELOGOUT);
      if (res?.status === "success") {
        toast.success("Force Logout Success");
      }
    } catch (err) {
      console.log("Error", err);
    }
  };

  return (
    <div>
      <Topbar header={"Settings"} subHead={"Audit Log"} />
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26">
          Audit Logs
        </h2>
        <div className="d-flex gap-3" style={{ alignItems: "center" }}>
          <div className="search-input">
            <input
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
              onChange={handleSearchChange}
            />
            <img src={Search_icon} className="search" alt="search" />
          </div>
          {checkPermission("CAN-EDIT-AUDIT_LOG") && (
            <>
              <button
                onClick={handlerForceLogout}
                className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn"
              >
                Force Log Out
              </button>
            </>
          )}
        </div>
      </div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={isAuditLog}
        show={true}
      />
    </div>
  );
}

export default AuditLog;
